"use client";
import React from "react";

import { Box } from "../../foundations";
import { SliderPropsWithDefaults } from "./types";

interface SliderHandleProps {
  fillClassName: string;
  labelId: string;
  onFocus: (e: React.FocusEvent) => void;
  onKeyDown: (e: React.KeyboardEvent) => void;
  onPointerDown: (e: React.PointerEvent) => void;
  slider: SliderPropsWithDefaults;
  value: number;
}

export const SliderHandle: React.FC<SliderHandleProps> = ({
  fillClassName,
  labelId,
  onFocus,
  onKeyDown,
  onPointerDown,
  slider,
  value
}) => {
  const length = slider.max - slider.min;

  return (
    <Box
      aria-labelledby={labelId}
      aria-valuemax={slider.max}
      aria-valuemin={slider.min}
      aria-valuenow={value}
      as="button"
      onFocus={onFocus}
      onKeyDown={onKeyDown}
      onPointerDown={onPointerDown}
      role="slider"
      sx={{
        cursor: slider.disabled ? "not-allowed" : "pointer",
        display: "block",
        height: 8,
        left: 0,
        marginInlineStart: -3,
        position: "absolute",
        top: 0,
        transform: ({ sizes }) =>
          `translateX(min(max(${((value - slider.min) / length) * 100}cqw, ${sizes[1] / 2}px), calc(100cqw - ${sizes[1] / 2}px)))`,
        userSelect: false,
        width: 6,
        [`:focus-visible .${fillClassName}`]: slider.disabled
          ? {}
          : {
              outline: "2px solid",
              outlineColor: "focus",
              outlineOffset: "2px"
            }
      }}
    >
      <Box
        as="span"
        className={fillClassName}
        sx={{
          borderRadius: "radius-1",
          display: "block",
          height: "100%",
          left: "50%",
          marginInlineStart: ({ sizes }) => `-${sizes[1] / 2}px`,
          position: "relative",
          width: 1
        }}
      />
    </Box>
  );
};
